import React from "react";
import { TableColumnsItem } from "../../interfaces/components/mainTable";
import { ColumnType, ButtonType } from "../utils/enums";
import { Edit, Trash } from "lucide-react";

// You should create a proper interface for the Doctor object
// For now, we'll use 'any' as it is in the original component
interface Doctor {
  id: string | number;
  title?: string;
  firstName: string;
  lastName: string;
  [key: string]: any;
}

interface DoctorColumnHandlers {
  onEdit: (doctor: Doctor) => void;
  onDelete: (doctor: Doctor) => void;
}

export const getDoctorsTableColumns = (
  handlers: DoctorColumnHandlers,
): TableColumnsItem[] => [
  {
    key: "fullName",
    name: "Doctor Name",
    type: ColumnType.CUSTOM,
    width: "220px",
    cardTitle: true,
    customValue: (row: Doctor) =>
      `${row.title || ""} ${row.firstName} ${row.lastName}`.trim(),
  },
  {
    key: "department",
    name: "Department",
    type: ColumnType.TEXT,
    width: "180px",
    cardOrder: 1,
  },
  {
    key: "specialization",
    name: "Specialization",
    type: ColumnType.TEXT,
    width: "200px",
    cardOrder: 2,
  },
  {
    key: "email",
    name: "Email",
    type: ColumnType.TEXT,
    width: "220px",
    cardOrder: 3,
  },
  {
    key: "phone",
    name: "Phone",
    type: ColumnType.TEXT,
    width: "140px",
    cardOrder: 4,
  },
  {
    key: "status",
    name: "Status",
    type: ColumnType.STATUS,
    width: "120px",
    cardOrder: 5,
  },
  {
    key: "actions",
    name: "Actions",
    type: ColumnType.BUTTON,
    width: "100px",
    cardOrder: 999,
    buttonsList: [
      {
        type: ButtonType.ICON,
        icon: Edit,
        onPress: (e: React.MouseEvent, row: Doctor) => handlers.onEdit(row),
        cssClass: "edit-button",
      },
      {
        type: ButtonType.ICON,
        icon: Trash,
        onPress: (e: React.MouseEvent, row: Doctor) => handlers.onDelete(row),
        cssClass: "delete-button",
      },
    ],
  },
];
